import { useSelector } from "react-redux";
import { RootState } from "../store";

export const useUserSelector = () =>
  useSelector((state: RootState) => state.auth.user);

export const useAuthTypeSelector = () =>
  useSelector((state: RootState) => state.auth.authType);

export const useGradeFileSelector = () =>
  useSelector((state: RootState) => state.gradeFile.gradeFile);

export const useGradeFileTypeSelector = () =>
  useSelector((state: RootState) => state.gradeFile.type);

export const useGradeFileGradeMapIdxSelector = () =>
  useSelector((state: RootState) => state.gradeFile.gradeMapIdx);

export const useGradeFileExchangedSelector = () =>
  useSelector((state: RootState) => !!state.gradeFile.gradeFile?.exchanged);

export const useGradeFileShowSubstituteSelector = () =>
  useSelector(
    (state: RootState) => !!state.gradeFile.gradeFile?.showSubstitute
  );

export const useSemesterStateSelector = () =>
  useSelector((state: RootState) => state.gradeFile.semesterState);

export const useExcelPopupSelector = () =>
  useSelector((state: RootState) => state.gradeFile.excelPopup);

export const useSubjectFormDataSelector = () =>
  useSelector((state: RootState) => state.gradeFile.subjectFormData);

export const useSemesterFormDataSelector = () =>
  useSelector((state: RootState) => state.gradeFile.semesterFormData);

export const useThemeWrapperSelector = () =>
  useSelector((state: RootState) => state.themeWrapper);

export const useColorsWrapperSelector = () =>
  useSelector((state: RootState) => state.themeWrapper.COLORS);

export const useFooterVisibleSelector = () =>
  useSelector((state: RootState) => state.themeWrapper.footerVisible);

export const useSnowFlakeButtonVisibleSelector = () =>
  useSelector((state: RootState) => state.themeWrapper.snowFlakeButtonVisible);

export const usePracticeRoomSelector = () =>
  useSelector((state: RootState) => state.practiceRoom);

export const usePracticeRoomResultsSelector = () =>
  useSelector((state: RootState) => state.practiceRoom.results);

export const usePracticeRoomQuestionsSelector = () =>
  useSelector((state: RootState) => state.practiceRoom.questions);

export const usePracticeRoomPractice = () =>
  useSelector((state: RootState) => state.practiceRoom.practice);

export const usePracticeRoomPracticeDescriptionSelector = () =>
  useSelector((state: RootState) => state.practiceRoom.practiceDescription);

export const usePracticeRoomDustySelector = () =>
  useSelector((state: RootState) => state.practiceRoom.dusty);

export const usePracticeRoomTypeConfigSelector = () =>
  useSelector((state: RootState) => state.practiceRoom.config.practiceType);

export const usePracticeRoomShouldShowingSummarySelector = () =>
  useSelector((state: RootState) => state.practiceRoom.shouldShowingSummary);

export const usePracticeSufferIndexesSelector = () =>
  useSelector((state: RootState) => state.practiceRoom.sufferIndexes);

export const useQuestionsPreviewDataSelector = () =>
  useSelector((state: RootState) => state.practiceRoom.questionsPreviewData);

export const usePracticeRoomTotalTimeSelector = () =>
  useSelector((state: RootState) => state.practiceRoom.totalTime);

export const useNotesSelector = () =>
  useSelector((state: RootState) => state.notes.notes);

export const useCategoriesSelector = () =>
  useSelector((state: RootState) => state.notes.categories);

export const useSelectedCategoryIdSelector = () =>
  useSelector((state: RootState) => state.notes.selectedCategoryId);

export const useNotesModalSelector = () =>
  useSelector((state: RootState) => state.notes.notesModal);

export const useNotesByCategorySelector = (categoryId: string | null) =>
  useSelector((state: RootState) => 
    categoryId 
      ? state.notes.notes.filter(note => note.categoryId === categoryId)
      : state.notes.notes
  );

export const useNotesBySemesterSelector = (semesterId?: number) =>
  useSelector((state: RootState) => {
    if (!semesterId) return [];
    const semesterCategoryId = `semester_${semesterId}`;
    return state.notes.notes.filter(note => note.categoryId === semesterCategoryId);
  });

export const useFavoriteNotesSelector = () =>
  useSelector((state: RootState) =>
    state.notes.notes.filter(note => note.isFavorite)
  );
